<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
   <BreadcrumbMenu pageTitle="Series de documentos" />
   <div class="flex-grow-1 overflow-auto px-3 pb-3">
    <div class="series-page">
    <div class="toolbar">
      <div class="pc-field">
        <label for="pc">PC / sede</label>
        <select id="pc" v-model.number="pcSeleccionada" @change="cargarSeries">
          <option v-for="pc in pcs" :key="pc.id" :value="pc.id">
            {{ pc.almacen }} - {{ pc.pc }} ({{ pc.cantidad_series }} series)
          </option>
        </select>
      </div>
      <button class="btn-primary" type="button" @click="abrirNuevo" :disabled="!pcSeleccionada">
        + Nueva serie
      </button>
    </div>

    <div class="notice">
      <strong>Importante:</strong> el correlativo guardado es el último utilizado; el siguiente documento usará el número mostrado en “Próximo”.
    </div>
    <p v-if="error" class="error">{{ error }}</p>

    <section v-for="grupo in grupos" :key="grupo.key" class="series-section">
      <header>
        <div>
          <h2>{{ grupo.titulo }}</h2>
          <p>{{ grupo.descripcion }}</p>
        </div>
        <span>{{ grupo.items.length }} series</span>
      </header>
      <div class="table-scroll">
        <table>
          <thead><tr><th>ID</th><th>Tipo de documento</th><th>Serie</th><th>Último correlativo</th><th>Próximo</th><th>Estado</th><th></th></tr></thead>
          <tbody>
            <tr v-for="item in grupo.items" :key="item.idserie">
              <td>{{ item.idserie }}</td><td>{{ item.tipo_documento }}</td><td><strong>{{ item.serie }}</strong></td>
              <td>{{ item.correlativo }}</td><td><strong>{{ item.serie }}-{{ pad(item.siguiente) }}</strong></td>
              <td><span :class="['status', item.estado ? 'active' : 'inactive']">{{ item.estado ? 'Activa' : 'Inactiva' }}</span></td>
              <td><button class="icon-btn" title="Editar serie" aria-label="Editar serie" @click="abrirEditar(item)">✎</button></td>
            </tr>
            <tr v-if="!grupo.items.length"><td colspan="7" class="empty">No hay series configuradas para esta PC.</td></tr>
          </tbody>
        </table>
      </div>
    </section>

    <div v-if="modal" class="modal-backdrop" @click.self="cerrarModal">
      <form class="modal-panel" @submit.prevent="guardar">
        <header><h2>{{ form.idserie ? 'Editar serie' : 'Nueva serie' }}</h2><button type="button" class="close" @click="cerrarModal">×</button></header>
        <div class="form-grid">
          <label>PC / sede<select v-model.number="form.idpcscursal" required><option v-for="pc in pcs" :key="pc.id" :value="pc.id">{{ pc.almacen }} - {{ pc.pc }}</option></select></label>
          <label>Tipo de documento<select v-model.number="form.idtipodoc" required><option v-for="tipo in tipos" :key="tipo.idtipodoc" :value="tipo.idtipodoc">{{ tipo.nombre }} ({{ tipo.oficial ? 'SUNAT' : 'No oficial' }})</option></select></label>
          <label>Serie<input v-model.trim="form.serie" maxlength="4" required placeholder="Ej. 0003" /></label>
          <label>Último correlativo<input v-model.number="form.correlativo" type="number" min="0" required /></label>
        </div>
        <label class="toggle"><input v-model="form.estado" type="checkbox" /> Serie activa</label>
        <div class="preview">Próximo documento: <strong>{{ form.serie || 'SERIE' }}-{{ pad(Number(form.correlativo || 0) + 1) }}</strong></div>
        <p v-if="modalError" class="error">{{ modalError }}</p>
        <footer><button type="button" class="btn-secondary" @click="cerrarModal">Cancelar</button><button class="btn-primary" :disabled="guardando">{{ guardando ? 'Guardando...' : 'Guardar' }}</button></footer>
      </form>
    </div>
    </div>
   </div>
  </div>
</template>

<script>
import BreadcrumbMenu from '../../components/Common/BreadcrumbMenu.vue';
import MainHeader from '../../components/Layouts/MainHeader.vue';
import MainSidebar from '../../components/Layouts/MainSidebar.vue';
import api from '../../services/api';

export default {
  name: 'SeriesDocumentosPage', components: { BreadcrumbMenu, MainHeader, MainSidebar },
  data: () => ({ pcs: [], tipos: [], series: [], pcSeleccionada: null, modal: false, guardando: false, error: '', modalError: '', form: {} }),
  computed: {
    grupos() { return [
      { key: 'oficial', titulo: 'Documentos oficiales SUNAT', descripcion: 'Boletas, facturas y notas de crédito electrónicas o de contingencia.', items: this.series.filter(x => x.oficial) },
      { key: 'otros', titulo: 'Documentos no oficiales', descripcion: 'Guías internas, guías de remisión, tickets, pedidos y otros documentos operativos.', items: this.series.filter(x => !x.oficial) },
    ]; },
  },
  async mounted() {
    try {
      const [pcs, tipos] = await Promise.all([api.get('/series-documentos/pcs'), api.get('/series-documentos/tipos')]);
      this.pcs = pcs.data.data; this.tipos = tipos.data.data;
      const usuario = JSON.parse(localStorage.getItem('user') || '{}');
      const mismaSede = this.pcs.filter(pc => !usuario.idalmacen || Number(pc.idsucursal) === Number(usuario.idalmacen));
      const candidatas = mismaSede.length ? mismaSede : this.pcs;
      const conSeries = candidatas.filter(pc => Number(pc.cantidad_series) > 0);
      const preferida = conSeries.find(pc => pc.pc === 'ALMACENC9') || conSeries[0] || candidatas[0];
      this.pcSeleccionada = preferida?.id || null;
      await this.cargarSeries();
    } catch (e) { this.error = e.response?.data?.error || 'No se pudo cargar la configuración.'; }
  },
  methods: {
    pad(n) { return String(n || 0).padStart(7, '0'); },
    async cargarSeries() { if (!this.pcSeleccionada) return; const r = await api.get('/series-documentos', { params: { idpcscursal: this.pcSeleccionada } }); this.series = r.data.data; },
    abrirNuevo() { this.form = { idserie: null, idpcscursal: this.pcSeleccionada, idtipodoc: this.tipos[0]?.idtipodoc, serie: '', correlativo: 0, estado: true }; this.modalError = ''; this.modal = true; },
    abrirEditar(item) { this.form = { ...item }; this.modalError = ''; this.modal = true; },
    cerrarModal() { this.modal = false; },
    async guardar() {
      this.guardando = true; this.modalError = '';
      try {
        const payload = { serie: this.form.serie, idtipodoc: this.form.idtipodoc, correlativo: this.form.correlativo, estado: this.form.estado, idpcscursal: this.form.idpcscursal };
        if (this.form.idserie) await api.put(`/series-documentos/${this.form.idserie}`, payload); else await api.post('/series-documentos', payload);
        this.pcSeleccionada = this.form.idpcscursal; this.modal = false; await this.cargarSeries();
      } catch (e) { this.modalError = e.response?.data?.error || 'No se pudo guardar la serie.'; }
      finally { this.guardando = false; }
    },
  },
};
</script>

<style scoped>
.series-page{padding-bottom:40px}.toolbar,.series-section,.notice{background:#fff;border:1px solid #dbe2ea;border-radius:6px}.toolbar{display:flex;align-items:end;justify-content:space-between;padding:18px;margin-bottom:14px}.pc-field{width:min(520px,70%)}label{display:flex;flex-direction:column;gap:7px;font-weight:600;color:#263143}select,input{height:44px;border:1px solid #cbd5e1;border-radius:4px;padding:0 12px;background:#fff}.btn-primary,.btn-secondary{height:44px;padding:0 18px;border-radius:4px;border:1px solid #2563eb}.btn-primary{background:#2563eb;color:#fff}.btn-secondary{background:#fff;color:#475569}.notice{padding:13px 16px;margin-bottom:16px;background:#eff6ff;border-color:#bfdbfe;color:#1e3a5f}.series-section{margin-bottom:18px;overflow:hidden}.series-section>header{display:flex;justify-content:space-between;padding:17px 18px;border-bottom:1px solid #e2e8f0}.series-section h2{font-size:18px;margin:0 0 4px}.series-section p{margin:0;color:#64748b}.table-scroll{overflow-x:auto}table{width:100%;border-collapse:collapse;min-width:840px}th,td{padding:13px 16px;text-align:left;border-bottom:1px solid #edf0f4}th{font-size:12px;text-transform:uppercase;color:#64748b;background:#f8fafc}.status{padding:4px 8px;border-radius:4px;font-size:12px;font-weight:700}.active{color:#087443;background:#dcfce7}.inactive{color:#64748b;background:#e2e8f0}.icon-btn,.close{border:0;background:transparent;font-size:22px}.empty{text-align:center;color:#64748b}.modal-backdrop{position:fixed;inset:0;background:rgba(15,23,42,.58);display:grid;place-items:center;z-index:10000;padding:20px}.modal-panel{width:min(680px,100%);background:#fff;border-radius:6px;padding:22px}.modal-panel header,.modal-panel footer{display:flex;align-items:center;justify-content:space-between}.modal-panel h2{font-size:20px}.form-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin:20px 0}.toggle{flex-direction:row;align-items:center}.toggle input{height:auto}.preview{margin:16px 0;padding:12px;background:#f8fafc}.modal-panel footer{justify-content:flex-end;gap:10px}.error{color:#b42318}.btn-primary:disabled{opacity:.55}@media(max-width:700px){.toolbar{align-items:stretch;gap:12px;flex-direction:column}.pc-field{width:100%}.form-grid{grid-template-columns:1fr}.modal-panel{max-height:90vh;overflow:auto}}
</style>
